/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import React from 'react';
import { Typography } from '@mui/material';

const Settings: React.FC = () => {
  return (
    <>
      <Typography variant='h4' m={"10px 10px"}>Settings</Typography>
    </>
  );
}

export default Settings;
